<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>商城管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item><a @click="jumpTo('/orderListNew')">新活动订单管理</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">

      <div class="contain_header clr">
        <el-form
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label='订单号'>
                <el-input
                  v-model="filters.title"
                  style="width:230px"
                  placeholder="请输入订单号"
                >
                </el-input>


              </el-form-item>
            </el-col>

            <el-col :span="7">
              <el-button
                style="margin-left:10px"
                @click="excelOut"
                type="danger"
                size="small"
              >导出订单</el-button>
              <el-button
                style="margin-left:10px"
                @click="handleSearch"
                type="primary"
                size="small"
              >搜索</el-button>
              <!-- <el-button
                v-show="provinceList == null"
                style="margin-left:10px"
                @click="excelOutSendMsg(1)"
                type="danger"
                size="small"
              >导出已发货信息</el-button>
              <el-button
                v-show="provinceList == null"
                style="margin-left:10px"
                @click="excelOutSendMsg(2)"
                type="danger"
                size="small"
              >导出待发货信息</el-button> -->
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="下单时间">
                <el-row>
                  <el-col :span="10">

                    <el-date-picker
                      type="date"
                      placeholder="选择开始日期"
                      v-model="filters.startTime"
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-col>

                  <el-col :span="1">
                    <div style="display: inline-block;width:100%;text-align:center">-</div>
                  </el-col>
                  <el-col :span="10">
                    <el-date-picker
                      type="date"
                      placeholder="选择结束日期"
                      v-model="filters.endTime"
                      style="width: 100%;"
                    ></el-date-picker>
                  </el-col>
                </el-row>

              </el-form-item>
            </el-col>

            <el-col
              :offset="1"
              :span="8"
            >

              <el-form-item label="订单状态">
                <el-select
                  v-model="filters.status"
                  clearable
                >
                  <el-option
                    v-for="option in typeOptions"
                    :value="option.id"
                    :key='option.id'
                    :label="option.title"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <el-form-item label="代理信息:">
                <el-input
                  style="width: 200px;"
                  v-model="filters.userInfo"
                  placeholder="请输入代理姓名或者手机号"
                >
                </el-input>

              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="收件人信息：">
                <el-input
                  style="width: 200px;"
                  v-model="filters.address"
                  placeholder="请输入收件人姓名或者手机号"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        <div style="width:10px;height:10px"></div>
      </div>
      <span class='totalM'>总金额：{{totalMoney.total_money}}元</span>
      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          v-loading='tableDataLoading'
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >

          <el-table-column
            prop="username"
            label="代理姓名"
          >
            <template slot-scope="scope">
              <span>{{scope.row.username}}</span>(<span>{{scope.row.telephone}}</span>)
            </template>
          </el-table-column>


          <el-table-column
            prop="order_code"
            label="订单号"
          >
          <template slot-scope="scope">
            <router-link
                target="_blank"
                :to="{path:'/orderDetailNew',query:{orderId:scope.row.id,sendName:scope.row.send_name}}"
              >{{scope.row.order_code}}
            </router-link>
          </template>
          </el-table-column>

          <!-- <el-table-column
            prop="send_name"
            v-if="filters.orderType == 1"
            label="发货人"
          >
          </el-table-column> -->

          <el-table-column
            prop="total_money"
            label="总金额"
          >
          </el-table-column>


          <el-table-colum
            prop="create_time"
            lable="下单时间"
          ></el-table-colum>

          <!-- <el-table-column
            prop="score_price"
            label="总积分"
          >
          </el-table-column> -->
          <!-- :show-overflow-tooltip="true" -->
          <!-- <el-table-column
            prop="create_time"
            label="下单时间"
          >
          </el-table-column> -->
          <!-- <el-table-column
            prop="order_type"
            :formatter="formatterOrderType"
            label="订单类型"
          >
          </el-table-column> -->

          <!-- <el-table-column
            prop="postage_status"
            v-if="filters.orderType == 1"
            label="包邮状态"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.postage_status == 1"
                type="success"
                disable-transitions
              >包邮</el-tag>
              <el-tag
                v-if="scope.row.postage_status == 2"
                type="info"
                disable-transitions
              >不包邮</el-tag>
            </template>
          </el-table-column> -->
          <!-- <el-table-column
            prop="postage_type"
            v-if="filters.orderType == 1"
            label="送货类型"
            width="150px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.postage_type == 1"
                type="success"
                disable-transitions
              >自提</el-tag>
              <el-tag
                v-if="scope.row.postage_type == 2"
                type="success"
                disable-transitions
              >快递</el-tag>
            </template>
          </el-table-column> -->

          <el-table-column
            v-if="filters.orderType == 1"
            prop="province"
            label="地址信息 "
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              {{scope.row.receiving_username }} {{scope.row.receiving_telephone }} {{scope.row.receiving_province }}{{scope.row.receiving_city }}{{scope.row.receiving_district }}{{scope.row.receiving_address_detail}}
            </template>
          </el-table-column>


          <el-table-column
            prop="status"
            :formatter="formatterStatus"
            label="状态"
          >
          </el-table-column>

          <!-- <el-table-column
            prop="order_info"
            label="订单备注"
          >
          </el-table-column> -->

          <el-table-column
            v-if="filters.orderType == 1"
            prop="send_time"
            label="发货时间"
            width="100"
          >
          </el-table-column>

          <!-- <el-table-column
            prop="no_vip"
            label="是否是耗材"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.no_vip == 1"
                type="success"
                disable-transitions
              >不是</el-tag>
              <el-tag
                v-if="scope.row.no_vip == 2"
                type="warn"
                disable-transitions
              >是</el-tag>
            </template>
          </el-table-column> -->

          <!-- <el-table-column
            v-if="filters.orderType == 1"
            prop="printStatus"
            label="是否打印"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.printStatus == 1"
                type="success"
                disable-transitions
              >不是</el-tag>
              <el-tag
                v-if="scope.row.printStatus == 2"
                type="warn"
                disable-transitions
              >是</el-tag>
            </template>
          </el-table-column> -->

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">

              <!-- <template v-if="scope.row.status==2">

                <el-button
                  @click="upHouseStatus(scope.row, 3)"
                  type="text"
                >取消订单</el-button>
              </template> -->
              <!-- <el-button
                v-if="scope.row.status == 12 && scope.row.buy_order_id != null"
                  @click="opBuOrder(scope.row, 1)"
                  type="text"
                >恢复补货单</el-button> -->

              <!-- <el-button
                v-if="scope.row.status == 9"
                @click="opBuOrder(scope.row, 2)"
                type="text"
              >过期补货单</el-button> -->
              <el-button v-if="scope.row.order_type == 1 && scope.row.status != 2"
                @click="editOrderCode(scope.row)"
                type="text"
              >修改单号</el-button>
              <el-button
                @click="excelOutDetail(scope.row)"
                type="text"
              >导出订单</el-button>
              <el-button
                v-if="filters.orderType == 1"
                @click="showOrderDetail(scope.row)"
                type="text"
              >打印出货单</el-button>
              <el-button v-if="hasPower('30091992')"
                @click="editRemarkCode(scope.row)"
                type="text"
              >修改备注</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="订单详情"
      :visible.sync="subListVisible"
      width="50%"
    >
    <div id = 'printTest'>
      <div class="contain_body_head">
        <div style="display: flex;justify-content: center;font-size: 33px;font-weight: 500;">出库单</div>
        <span>订单号：{{orderDD.order_code}}</span>
        <div style="display: flex;justify-content: space-between;">
          <span style="flex: 1 1 33.33%;">客户名称：{{orderDD.username}}</span>
          <span style="flex: 1 1 33.33%;">联系电话：{{orderDD.telephone}}</span>
          <span style="flex: 1 1 33.33%;">订单时间：{{orderDD.r_create_time}}</span>
        </div>
        <div style="display: flex;justify-content: space-between;">
          <span style="flex: 1 1 33.33%;">客户地址：{{orderDD.province }}{{orderDD.city }}{{orderDD.district }}{{orderDD.address_detail }}</span>
          <span style="flex: 1 1 33.33%;"></span>
          <span style="flex: 1 1 33.33%;">订单备注：{{orderDD.order_info}}</span>
        </div>
      </div>
      <el-table
        v-loading="subListLoading"
        :data="subList"
        show-summary
        max-height="800"
        style="width: 100%"
        :header-cell-class-name='objectSpanMethod'
      >
        <el-table-column
          prop="infoId"
          label="序号"
        >
        </el-table-column>
        <el-table-column
          prop="good_name"
          label="商品名称"
        >
        </el-table-column>

        <el-table-column
          prop="num"
          label="购买数量"
        >
        </el-table-column>

      </el-table>
    </div>
      <el-button style="margin-top:10px" v-print="'#printTest'">打印</el-button>
      <div style="height:10px;width:10px"></div>
      <div
        class="contain_body_head"
        v-show="buList.length > 0"
      >
        补货商品列表
      </div>
      <div v-show="buList.length > 0">

        <div
          v-for="item in buList"
          v-bind:key='item.id'
        >
          <div class="contain_body_head">
            {{item.order_code}},总金额：{{item.total_money}}元
          </div>
          <el-table
            v-loading="subListLoading"
            :data="item.sub"
            max-height="300"
            style="width: 100%"
            :header-cell-class-name='objectSpanMethod'
          >

            <el-table-column
              prop="good_name"
              label="商品名称"
            >
            </el-table-column>

            <el-table-column label="商品图片">
              <template slot-scope="scope">
                <img
                  :src="scope.row.list_pic"
                  style="width:50px;"
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="good_price"
              label="原价"
            >
            </el-table-column>

            <el-table-column
              prop="proxy_price"
              label="代理价"
            >
            </el-table-column>

            <el-table-column
              prop="num"
              label="购买数量"
            >
            </el-table-column>

          </el-table>
        </div>
      </div>

    </el-dialog>

    <el-dialog
      title="修改单号"
      :visible.sync="dialogAddVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        ref="editForm"
        size='small'
        :model="editForm"
        :rules="editFormRule"
      >


        <el-form-item
          label="单号"
          prop="orderCode"
        >
          <el-input
            v-model="editForm.orderCode"
            style="width:70%"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >修改</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>


    <el-dialog
      title="修改备注"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <el-form
        label-position="top"
        class="m-search"
        ref="editForm1"
        size='small'
        :model="editForm1"
        :rules="editFormRule1"
      >
        <el-form-item
          label="备注"
          prop="orderRemork"
        >
          <el-input
            v-model="editForm1.orderRemork"
            style="width:70%"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="postRemark()"
            :loading="addLoading"
          >修改</el-button>
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="批量发货"
      :visible.sync="dialogBatchInVisible"
      width="40%"
    >

      <!-- <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="规格名称"
          prop='excelFile'
        >
          <el-input
            type="file"
            @change="getFile"
            v-model="form.excelFile"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="batchInPost()"
            :loading="batchInPostLoading"
          >发货</el-button>
        </el-form-item>
      </el-form> -->

      <form>
        <input
          type="file"
          @change="getFile($event)"
        >
        <el-button
          :loading="batchInPostLoading"
          class="el-button el-button--primary el-button--small"
          @click="batchInPost($event)"
        >提交</el-button>
      </form>
      <div style="color: red;">
        <div
          v-for="item in errMsg"
          v-bind:key="item"
        ><span>{{item}}</span><br /></div>
      </div>
    </el-dialog>

  </el-main>
</template>


<script>
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "orderList",
  created() {},
  data() {
    return {
      editForm:{
        id:null,
        orderCode:null
      },
      editForm1:{
        id:null,
        orderRemork:null
      },
      subListVisible: false,
      totalMoney:{
        total_money:0,
        score_price:0
      },
      typeOptions: [
        {
          id: 1,
          title: "待支付"
        },
        {
          id: 2,
          title: "待发货"
        },
        {
          id: 3,
          title: "待收货"
        },
        {
          id: 4,
          title: "已完成"
        },
        {
          id: 5,
          title: "已取消"
        }
      ],
      orderTypeOne: [
        {
          id: 2,
          title: "待发货"
        },
        {
          id: 3,
          title: "待收货"
        },
        {
          id: 7,
          title: "待自提"
        },
        {
          id: 8,
          title: "已自提"
        },
        {
          id: 4,
          title: "已发货"
        }
      ],
      addExcelSnedLoading: false,
      errMsg: null,
      dialogBatchInVisible: false,
      batchInPostLoading: false,
      tableDataLoading: false,
      searchUserId: null,
      tableData1: [],
      addFormRule: {
        excelFile: [
          { required: true, message: "请选择Excel文件", trigger: "blur" }
        ]
      },
      addLoading:false,
      editFormRule: {
        orderCode: [
          { required: true, message: "请输入单号", trigger: "blur" }
        ]
      },
      editFormRule1: {
        orderRemork: [
          { required: true, message: "请输入备注", trigger: "blur" }
        ]
      },
      dialogAddVisible:false,
      dialogVisible:false,
      form: {
        excelFile: null
      },
      file: null,
      filters: {
        sendUser:null,
        expire_type:null,
        orderType: "1",
        address: null,
        title: null,
        status: null,
        send_type:null,
        startTime: null,
        roleType:null,
        endTime: null,
        status: null,
        userInfo: null,
        goodName: null,
        printStatus: null,
      },
      isCollapse: true,
      activeName: "second",
      page_num: 1,
      keywords: "",
      value4: "",
      subList: [],
      buList: [],
      pickerOptions1: 1,
      value2: "",
      options: ["阿德的", "豆得儿"],
      tableData: [],
      total_num: 0,
      subListLoading: false,
      total_page: 0,
      page_size: 10,
      tableHeight: null,
      orderDD:{},
      provinceOptions:[],
      provinceList:null,
    };
  },
  mounted() {
    this.provinceList  = localStorage.getItem("provinceList");
    if (this.provinceList && this.provinceList != null && this.provinceList != '')
    {
      this.provinceOptions = this.provinceList.split(',');
    }
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    showOrderDetail(row) {
      window.open('http://101.132.127.109/printNewH5.html?token='+localStorage.getItem("api_token")+'&id=' + row.id
      + '&status=' + row.status  + '&user_id=' + row.user_id
      );
      // let that = this;
      // that.orderDD = {};
      // that.subListVisible = true;
      // that.subListLoading = true;
      // let para = {
      //   token: localStorage.getItem("api_token"),
      //   id: row.id
      // };
      // API.good_order_detail(para)
      //   .then(
      //     function(result) {
      //       that.subListLoading = false;
      //       if (result && parseInt(result.key) === 1000) {
      //         that.subList = result.result.map.sub;
      //         that.orderDD = result.result.map;
      //         if (that.subList && that.subList != null && that.subList.length > 0)
      //         {
      //           for (var z=0; z<that.subList.length;z++)
      //           {
      //             that.subList[z].infoId = (z + 1);
      //           }
      //         }
      //         if (result.result.map.orders != null) {
      //           that.buList = result.result.map.orders;
      //         } else {
      //           that.buList = [];
      //         }
      //       }
      //     },
      //     function(err) {
      //       that.subListLoading = false;
      //       that.$message.error({
      //         showClose: true,
      //         message: err.toString(),
      //         duration: 2000
      //       });
      //     }
      //   )
      //   .catch(function(error) {
      //     that.subListLoading = false;
      //     console.log(error);
      //     that.$message.error({
      //       showClose: true,
      //       message: "请求出现异常",
      //       duration: 2000
      //     });
      //   });
    },
    changeTypeOption() {
      this.filters.status = null;
      if (parseInt(this.filters.orderType) == 1) {
        this.typeOptions = this.orderTypeOne;
      } else if (parseInt(this.filters.orderType) == 2) {
        this.filters.printStatus = null;
        this.typeOptions = [
          {
            id: 1,
            title: "待支付"
          },
          {
            id: 4,
            title: "已完成"
          },
          {
            id: 5,
            title: "已取消"
          }
        ];
      } else if (parseInt(this.filters.orderType) == 3) {
        this.filters.printStatus = null;
        this.typeOptions = [
          {
            id: 9,
            title: "待补货"
          }
        ];
      } else if (parseInt(this.filters.orderType) == 4) {
        this.filters.printStatus = null;
        this.typeOptions = [
          {
            id: 9,
            title: "待补货"
          },
          {
            id: 10,
            title: "待支付"
          },
          {
            id: 11,
            title: "已完成"
          },
          {
            id: 12,
            title: "已过期"
          }
        ];
      }
      this.handleSearch();
    },
    getFile(event) {
      this.file = event.target.files[0];
      console.log(this.file);
    },
    editOrderCode(row)
    {
      this.editForm.orderCode = null;
      this.editForm.id = row.id;
      this.dialogAddVisible = true;
    },
    editRemarkCode(row)
    {
      this.editForm1.orderRemork = null;
      this.editForm1.id = row.id;
      this.dialogVisible = true;
    },
    batchIn() {
      this.form.excelFile = null;
      this.file = null;
      this.dialogBatchInVisible = true;
    },
    addPost() {
      let that = this;
      that.$refs["editForm"].validate(valid => {
        if (valid) {
          that.addLoading = true;
          let para = {
            id:that.editForm.id,
            orderCode:that.editForm.orderCode
          };
          para.token = localStorage.getItem("api_token");
          API.H5_app_send_good(para)
            .then(
              function(result) {
                that.$refs["editForm"].resetFields();
                if (result.key == 1000) {
                  that.dialogAddVisible = false;
                  that.$message.success({
                    showClose: true,
                    message: "修改成功",
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 2981) {
                  that.$message.error({
                    showClose: true,
                    message: result.message,
                    duration: 1500
                  });
                  that.addLoading = false;
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
                that.addLoading = false;
              },
              function(err) {
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },


    postRemark() {
      let that = this;
      that.$refs["editForm1"].validate(valid => {
        if (valid) {
          that.addLoading = true;
          let para = {
            id:that.editForm1.id,
            remark:that.editForm1.orderRemork
            // order_info:that.editForm1.orderRemork
          };
          para.token = localStorage.getItem("api_token");
          API.H5_app_send_good(para)
            .then(
              function(result) {
                that.$refs["editForm1"].resetFields();
                if (result.key == 1000) {
                  that.dialogVisible = false;
                  that.$message.success({
                    showClose: true,
                    message: "修改成功",
                    duration: 1500
                  });
                  that.search();
                } else if (result.key == 2981) {
                  that.$message.error({
                    showClose: true,
                    message: result.message,
                    duration: 1500
                  });
                  that.addLoading = false;
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
                that.addLoading = false;
              },
              function(err) {
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    batchInPost(event) {
      event.preventDefault();
      var that = this;
      if (this.file == null) {
        that.$message.error({
          showClose: true,
          message: "请先上传需要导入的excel",
          duration: 2000
        });
        return;
      } else {
        that.addExcelSnedLoading = true;
        that.batchInPostLoading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        var ss = this.file.name
          .substr(this.file.name.lastIndexOf("."))
          .toUpperCase(); //得到的是后缀名,且转换为大写
        if (ss == ".XLS") {
          let config = {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          };

          API.import_car_info(formData, config)
            .then(
              function(result) {
                that.batchInPostLoading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (result.result.list.length == 0) {
                    that.dialogBatchInVisible = false;
                    that.$message.success({
                      showClose: true,
                      message: "发货成功",
                      duration: 1500
                    });
                    that.search();
                  } else {
                    that.errMsg = result.result.list;
                  }
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "请求失败，请检查文件格式和内容是否符合要求",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.batchInPostLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.batchInPostLoading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          this.errMsg = ["格式错误"];
          return;
        }
      }
    },

    excelOutDetail(row) {
      var that = this;
      var url =
      "/manager/user/pc/h5_order_detail_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&orderId=" + row.id;
      top.location.href = url;
    },
    printDetail(row) {
      var that = this;
      var url =
        "/manager/user/pc/order_detail_excel?token=" +
        localStorage.getItem("api_token");
      url = url + "&id=" + row.id;
      top.location.href = url;
    },

    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/h5_order_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.title) {
        url = url + "&orderCode=" + that.filters.title;
      }
      if (that.filters.userInfo) {
        url = url + "&userInfo=" + that.filters.userInfo;
      }
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      }
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      }
      if (that.filters.address) {
        url = url + "&address=" + that.filters.address;
      }
      if (that.filters.sendUser) {
        url = url + "&sendUser=" + that.filters.sendUser;
      }
      top.location.href = url;
    },
    excelOutSendMsg(type){
      var that = this;
      if(!that.filters.startTime){
        that.$message.error({
          showClose: true,
          message: "请选择开始时间",
          duration: 2000
        });
        return
      }
      if(!that.filters.endTime){
        that.$message.error({
          showClose: true,
          message: "请选择结束时间",
          duration: 2000
        });
        return
      }
      if(that.filters.endTime.getTime() < that.filters.startTime.getTime()){
        that.$message.error({
          showClose: true,
          message: "结束时间必须大于开始时间",
          duration: 2000
        });
        return
      }
      if(that.filters.endTime.getTime() - that.filters.startTime.getTime() > 31*24*60*60*1000){
        that.$message.error({
          showClose: true,
          message: "时间必须在一个月以内",
          duration: 2000
        });
        return
      }
      if(!that.filters.sendUser && type == 1){
        that.$message.error({
          showClose: true,
          message: "请选择发货人",
          duration: 2000
        });
        return
      }
      // if(!that.filters.status){
      //   that.$message.error({
      //      showClose: true,
      //      message: "请选择订单状态",
      //      duration: 2000
      //   });
      //   return
      // }
      var url =
        (type == 1 ? "/manager/user/pc/send_good_msg_excel?token=" : "/manager/user/pc/wa_send_good_msg_excel?token=") +
        localStorage.getItem("api_token");
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      }
      if (that.filters.sendUser) {
        url = url + "&sendKeyword=" + that.filters.sendUser;
      }
      if (that.filters.orderType) {
        url = url + "&orderType=" + that.filters.orderType;
      }
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      }
      // window.open("http://localhost:8839"+url,'_blank')
      top.location.href = url;
    },

    formatterStatus(row, column) {
      if (row.status == 1) {
        return "待支付";
      } else if (row.status == 2) {
        return "待发货";
      } else if (row.status == 3) {
        return "待收货";
      } else if (row.status == 4) {
        return "已完成";
      } else if (row.status == 5) {
        return "已取消";
      } else if (row.status == 7) {
        return "待自提";
      } else if (row.status == 8) {
        return "已自提";
      } else if (row.status == 9) {
        return "待补货";
      } else if (row.status == 10) {
        return "补货待支付";
      } else if (row.status == 11) {
        return "补货已完成";
      } else if (row.status == 12) {
        if (row.expire_type == null) {
          return "补货已过期";
        } else {
          if (row.expire_type == 1) {
            return "超时未支付过期";
          } else if (row.expire_type == 2) {
            return "超时未补货过期";
          }
        }
      }
    },

    formatterOrderType(row, column) {
      if (row.order_type == 1) {
        return "发货订单";
      } else if (row.order_type == 2) {
        return "购进订单";
      } else if (row.order_type == 3) {
        return "待补货订单";
      } else if (row.order_type == 4) {
        return "已补货订单";
      }
    },

    upHouse(row) {
      this.$router.push({ path: "/up_article", query: { id: row.id } });
    },

    opBuOrder(row, status) {
      var msg = "";
      var com = "";
      if (status == 1) {
        msg = "确定恢复该补货单吗？";
        com = "恢复成功后，有一天付款时间。";
      } else {
        msg = "确定过期该补货单吗？";
        com = "提示";
      }
      let that = this;
      this.$confirm(msg, com, { type: "info" })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
            status: status
          };
          API.op_bu_order(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "申请成功",
                    duration: 1500
                  });
                  that.search();
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },

    upHouseStatus(row, status) {
      if (status == 2) {
        let that = this;
        this.$confirm("确定禁用该用户吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              ids: row.id,
              status: status
            };
            API.status_normal_user(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "禁用成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 3) {
        let that = this;
        this.$confirm("确定取消该订单吗?", "提示", { type: "info" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.apply_return(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "取消成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      } else if (status == 1) {
        let that = this;
        this.$confirm("确定发货吗?", "提示", { type: "warning" })
          .then(() => {
            that.loading = true;
            let para = {
              token: localStorage.getItem("api_token"),
              id: row.id
            };
            API.send_good(para)
              .then(
                function(result) {
                  that.loading = false;
                  if (result && parseInt(result.key) === 1000) {
                    that.$message.success({
                      showClose: true,
                      message: "发货成功",
                      duration: 1500
                    });
                    that.search();
                  }
                },
                function(err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000
                  });
                }
              )
              .catch(function(error) {
                that.loading = false;
                console.log(error);
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000
                });
              });
          })
          .catch(() => {});
      }
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.title) {
        params.orderCode = that.filters.title;
      }
      if (that.filters.userInfo) {
        params.userInfo = that.filters.userInfo;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      }
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (that.filters.address) {
        params.reInfo = that.filters.address;
      }
      if (that.filters.sendUser) {
        params.sendUser = that.filters.sendUser;
      }
      that.tableDataLoading = true;
      API.h5_order_list(params)
        .then(
          function(result) {
            that.tableDataLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  result.result.list[i].create_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].create_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  if (result.result.list[i].send_time != null)
                  {
                    result.result.list[i].send_time = dateFunc.formatDate(
                    new Date(parseInt(result.result.list[i].send_time)),
                    "yyyy-MM-dd hh:mm:ss"
                  );
                  }
                }
              }
              that.tableData = result.result.list;
              that.totalMoney.total_money = result.result.map.totalMoney;
            }
          },
          function(err) {
            that.tableDataLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.tableDataLoading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
      // API.order_money(params)
      //   .then(
      //     function(result) {
      //       if (result.key == 1000) {
      //         that.totalMoney = result.result.map;
      //       }
      //     },
      //     function(err) {
      //       that.tableDataLoading = false;
      //       that.$message.error({
      //         showClose: true,
      //         message: err.toString(),
      //         duration: 2000
      //       });
      //     }
      //   )
      //   .catch(function(error) {
      //     that.tableDataLoading = false;
      //     console.log(error);
      //     that.$message.error({
      //       showClose: true,
      //       message: "请求出现异常",
      //       duration: 2000
      //     });
      //   });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    },
    hasPower(power) {
      let powers = localStorage.getItem("powers");
      powers = JSON.parse(powers);
      var has = false;
      for (var i = 0; i < powers.length; i++) {
        if (powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.totalM
{
      display: inline-block;
    margin-top: 10px;
    font-size: 20px;
    margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/good/orderListNew.vue